import { useConfig } from "@kaltura/mediaspace-shared-data-kms-config";
import Lobby from "../lobby/Lobby";
import { HeroProps } from "../HeroProps";
import { useKalturaServerTime } from "@kaltura/mediaspace-shared-hooks";
import { CommonHeroLayout } from "../layout/CommonHeroLayout";
import { getPropsToPass, useThumbnailSizing } from "../helpers";
import { MediaLobbyDataContainer } from "../lobby/lobby-data/LobbyData";

/**
 * wrapper component for Lobby-Only media
 */
const LobbyOnlyHero = (props: HeroProps) => {
    const { thumbnailUrl, schedulingData, entry, actions = [] } = props;

    const context = useConfig();

    // get time from server, then init accordingly
    // will be used in lobby counter
    useKalturaServerTime(context.application.serviceUrl);

    const { statusLabel, actionsToPass } = getPropsToPass(entry, schedulingData, actions);

    const sizedThumbnailUrl = useThumbnailSizing(thumbnailUrl);

    return (
        <CommonHeroLayout collapsedHero={props.collapse}>
            <Lobby
                thumbnailUrl={sizedThumbnailUrl}
                statusLabel={statusLabel}
                title={entry.name}
                schedulingData={schedulingData}
                actions={actionsToPass}
                data={<MediaLobbyDataContainer {...props} />}
            />
        </CommonHeroLayout>
    );
};

export default LobbyOnlyHero;
